<template>
    <div class=content-blocks>

        <component v-for="(block, i) in blocks"
            :key="i"
            :is="block.acf_fc_layout"
            :accordionTitle="block.accordion_title"
            :accordionContent="block.accordion_content"
            :textContent="block.text_content"
            :buttonText="block.buttonText"
            @button-click="$emit('button-click')"
        />

    </div>
</template>
<script>

import accordion from './acf/Accordion.vue';
import textBlock from './acf/TextBlock.vue';
import buttonBlock from './acf/ButtonBlock.vue';

export default {
    name  : 'ContentBlocks',
    props : {
        blocks : Array,
    },
    components : {
        accordion   ,
        textBlock   ,
        buttonBlock ,
    }
}
</script>